import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { h } from '@debbie/cortex/dist';
import * as connect from '@debbie/cortex/dist/connect';
import { load } from '../connect/utils';
import Errors from '../Errors';
const ConnectPreview = (props) => {
    const preview = connect.useConnectConnection(props.id);
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        h.isError(preview) ? React.createElement(Errors, { errors: [preview.error.message] }) : null,
        load({ preview }, ({ preview }) => {
            return (
            // @ts-ignore
            React.createElement(Link, { to: `/connect/connections/${props.id}` }, lang.connect.goToConnection));
        }, 'loading')));
};
export default ConnectPreview;
//# sourceMappingURL=ConnectPreview.js.map